import { ProductAvailabilityTemplateDetailPage } from '@/features/product-availability-template/pages/ProductAvailabilityTemplateDetailPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/admin/product-availability-template/$id/detail',
)({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_availability_template.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAvailabilityTemplateDetailPage,
})
